import { IllustrativeBadge } from "@/components/IllustrativeBadge";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-stone-200 bg-mill-alt/50" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="max-w-xl">
            <p className="font-display text-sm font-semibold text-mill-ink">The Mill — People, Places & Practice Canvas</p>
            <p className="mt-1 text-sm text-mill-muted">
              A private design instrument, v0.1. Not a live product, procurement recommendation or commitment by The Mill.
            </p>
          </div>
          <IllustrativeBadge />
        </div>
        <p className="mt-6 text-xs leading-relaxed text-mill-muted">
          Uses approved public context, anonymised aggregate measures, and fictional identities, bookings and returns only.
          No real participant, volunteer or staff records, contact data, safeguarding, health, financial or wallet data are used.
        </p>
      </div>
    </footer>
  );
}
